import React from "react"

const OrganisationManageContext = React.createContext({})

const { Provider, Consumer } = OrganisationManageContext

export { Provider, Consumer, OrganisationManageContext }
